export enum EGlobalStateKeys {
    user = 'user'
}
